import React from 'react';
import Feed from '../components/Feed';

export default function MobileFeed() {
  return <Feed />;
}
